import { inr0 } from "@/lib/format";

const SOURCES = [["collection", "Customer payments (credit collected)"], ["membership", "Membership fees"], ["stall", "Stall sales (B2P)"], ["other", "Other income"]];

const Line = ({ label, value, bold, testid }) => (
  <div className={`flex justify-between border-b border-[#F1EDE3] py-2 text-sm ${bold ? "font-semibold" : ""}`} data-testid={testid}><span>{label}</span><span className="font-mono">{inr0(value)}</span></div>
);

export const PnlTab = ({ pnl }) => {
  if (!pnl) return null;
  const profit = pnl.profit >= 0;
  return (
    <div className="space-y-4" data-testid="pnl-tab">
      <div className={`rounded-2xl p-5 ${profit ? "bg-emerald-50" : "bg-rose-50"}`} data-testid="pnl-profit">
        <div className="text-xs uppercase tracking-wider text-muted-foreground">{profit ? "Profit" : "Loss"} this month</div>
        <div className={`font-display text-3xl font-bold ${profit ? "text-emerald-700" : "text-rose-700"}`}>{inr0(Math.abs(pnl.profit))}</div>
        <div className="mt-1 text-xs text-muted-foreground">Money received {inr0(pnl.income_total)} minus expenses {inr0(pnl.expense_total)}. Batter billed this month: {inr0(pnl.billed_sales)} (credit not yet collected is not counted as income).</div>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        <div className="rounded-2xl border border-[#E7E2D6] bg-white p-4">
          <div className="mb-1 font-semibold">Income</div>
          {SOURCES.map(([k, l]) => <Line key={k} label={l} value={pnl.income[k]} testid={`pnl-income-${k}`} />)}
          <Line label="Total income" value={pnl.income_total} bold testid="pnl-income-total" />
        </div>
        <div className="rounded-2xl border border-[#E7E2D6] bg-white p-4">
          <div className="mb-1 font-semibold">Expenses</div>
          {pnl.expenses.length === 0 && <div className="py-2 text-sm text-muted-foreground">No expenses recorded</div>}
          {pnl.expenses.map((c) => <Line key={c.category} label={c.category} value={c.amount} testid={`pnl-exp-${c.category}`} />)}
          <Line label="Total expenses" value={pnl.expense_total} bold testid="pnl-expense-total" />
        </div>
      </div>
    </div>
  );
};
